import React, { forwardRef } from 'react';

/**
 * Shared text input using design system .input-mdl style.
 * Use for forms and modals so all inputs look consistent.
 * forwardRef so react-hook-form register() attaches correctly to the DOM input.
 */
interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  className?: string;
}

const Input = forwardRef<HTMLInputElement, InputProps>(function Input({ className = '', ...props }, ref) {
  return <input ref={ref} className={`input-mdl ${className}`.trim()} {...props} />;
});

Input.displayName = 'Input';

export default Input;
